export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11166.9c44150d.jpg";